import { reactive } from "vue";

export function useContactFormValidation() {
  const form = reactive({
    df_name: "",
    df_surname: "",
    // df_company: "",
    df_emailaddress: "",
    df_phone: "",
    cf_76: "",
    cf_68: "", // Chci být kontaktován ohledně
    cf_138: "41", // Zasedací místnost
    cf_126: "", // Datum
    cf_141: "", // Od kolika hodin
    cf_144: "38", // Počet hodin rezervace

    cf_129: "", // Název / Typ akce
    cf_135: "", // Předpokládaný počet hostů
    cf_132: "", // Časový rozsah akce

    cf_62: "", // poznámka
  });

  const defaultValues = {cf_138: 41, cf_144: 38};

  const errors = reactive({
    df_name: "",
    df_surname: "",
    // df_company: "",
    df_emailaddress: "",
    df_phone: "",
  });

  function validateEmail(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  function validatePhone(phone) {
    const regex = /^(\+\d{3}\d{9}|\d{9})$/;
    return regex.test(phone);
  }

  function validateForm() {
    let valid = true;

    Object.keys(errors).forEach((key) => (errors[key] = ""));

    if (!form.df_name) {
      errors.df_name = "Jméno je povinné pole";
      valid = false;
    }

    if (!form.df_surname) {
      errors.df_surname = "Příjmení je povinné pole";
      valid = false;
    }

    // if (!form.df_company) {
    //   errors.df_company = "Společnost je povinné pole";
    //   valid = false;
    // }

    if (!form.df_emailaddress) {
      errors.df_emailaddress = "E-mail je povinné pole";
      valid = false;
    } else if (!validateEmail(form.df_emailaddress)) {
      errors.df_emailaddress = "Neplatná e-mailová adresa";
      valid = false;
    }

    if (!form.df_phone) {
      errors.df_phone = "Telefon je povinné pole";
      valid = false;
    } else if (!validatePhone(form.df_phone)) {
      errors.df_phone = "Telefon musí být ve správném tvaru";
      valid = false;
    }

    // cf_76: "",
    // cf_68: "", // Chci být kontaktován ohledně
    // cf_138: "", // Zasedací místnost
    // cf_126: "", // Datum
    // cf_141: "", // Od kolika hodin
    // cf_144: "", // Počet hodin rezervace

    // cf_129: "", // Název / Typ akce
    // cf_135: "", // Předpokládaný počet hostů
    // cf_132: "", // Časový rozsah akce

    var otherRequiredFields = [];

    // Pronájmu zasedací místnosti
    if (form.cf_68 == 8) {
        otherRequiredFields = ['cf_138', 'cf_126', 'cf_141', 'cf_144'];
    }
    
    if (form.cf_68 == 5) {
        otherRequiredFields = ['cf_129', 'cf_135', 'cf_132', 'cf_126'];
    }

    if (otherRequiredFields.length) {
        for (let field of otherRequiredFields) {
            if (typeof defaultValues[field] !== 'undefined' && defaultValues[field] == form[field]) {
                errors[field] = "Toto pole je povinné.";
                valid = false;
            }

            if (!form[field]) {
                errors[field] = "Toto pole je povinné.";
                valid = false;
            }
        }
    }

    return valid;
  }

  return {
    form,
    errors,
    validateForm,
  };
}